import {
  COMPANY_DIRECT_DEBIT_BANK_DETAILS,
  COMPANY_SELLER_BANK_ACCOUNT,
  COMPANY_TRADE_PARTNERS,
  DIRECT_DEBIT_ACCOUNT_ACCOUNT_HOLDER,
  DIRECT_DEBIT_ACCOUNT_ACCOUNT_NUMBER,
  DIRECT_DEBIT_ACCOUNT_BANK_CODE,
  DIRECT_DEBIT_ACCOUNT_BANK_NAME,
  DIRECT_DEBIT_ACCOUNT_CITY,
  DIRECT_DEBIT_ACCOUNT_COUNTRY_CODE,
  DIRECT_DEBIT_ACCOUNT_STATE,
  DIRECT_DEBIT_ACCOUNT_STREET_NAME,
  DIRECT_DEBIT_ACCOUNT_STREET_NUMBER,
  DIRECT_DEBIT_ACCOUNT_ZIP_CODE,
  SELLER_BANK_ACCOUNT_ACCOUNT_HOLDER,
  SELLER_BANK_ACCOUNT_ACCOUNT_NUMBER,
  SELLER_BANK_ACCOUNT_BANK_CODE,
  SELLER_BANK_ACCOUNT_CURRENCIES,
  SELLER_BANK_ACCOUNT_TRANSFER_TYPE,
  TRADE_PARTNER_AGREEMENT,
  TRADE_PARTNER_AIRWAY_BILL_DOCUMENT,
  TRADE_PARTNER_AVERAGE_INVOICE_AMOUNT,
  TRADE_PARTNER_BILL_OF_LADING_DOCUMENT,
  TRADE_PARTNER_CRM_CIM_DOCUMENT,
  TRADE_PARTNER_DOCUMENTS_ROUTED_THROUGH_BANK,
  TRADE_PARTNER_EBRC_DOCUMENT,
  TRADE_PARTNER_EXPECTED_EXPORT_VOLUME,
  TRADE_PARTNER_HAS_DELAY_IN_PAYMENTS,
  TRADE_PARTNER_HAS_TRADE_HISTORY,
  TRADE_PARTNER_INSURANCE_PARTNERS,
  TRADE_PARTNER_INVOICE_DOCUMENT,
  TRADE_PARTNER_LIMIT_ALLOCATION,
  TRADE_PARTNER_MAXIMUM_DELAY_IN_DAYS,
  TRADE_PARTNER_MAXIMUM_PAYMENT_TERM,
  TRADE_PARTNER_OUTSTANDING_BALANCE,
  TRADE_PARTNER_PAYMENT_REFERENCE_TYPE,
  TRADE_PARTNER_PROOF_OF_PAYMENT,
  TRADE_PARTNER_PURCHASE_ORDER_DOCUMENT,
  TRADE_PARTNER_SAMPLE_DOC_STATEMENT_OF_ACCOUNTS,
  TRADE_PARTNER_SAMPLE_DOC_AGING_REPORT,
  TRADE_PARTNER_SUPPORTING_DOCUMENT,
  TRADE_PARTNER_TOTAL_EXPORT_VOLUME,
  TRADE_PARTNER_TRADING_CURRENCY,
  TRADE_PARTNER_TRADING_SINCE,
  TRADE_PARTNER_VIRTUAL_CREDIT_LIMIT,
} from '@modifi/plugin-onboarding'

/**
 * Mapping of input fields of complex types to their parent
 */
export const INPUT_FIELD_TO_VERIFIABLE_PARENT_MAPPING: Record<string, string> = {
  // SELLER TRADE PARTNERS (buyers in seller financing)
  [TRADE_PARTNER_INSURANCE_PARTNERS]: COMPANY_TRADE_PARTNERS,
  [TRADE_PARTNER_VIRTUAL_CREDIT_LIMIT]: COMPANY_TRADE_PARTNERS,
  [TRADE_PARTNER_LIMIT_ALLOCATION]: COMPANY_TRADE_PARTNERS,
  [TRADE_PARTNER_HAS_TRADE_HISTORY]: COMPANY_TRADE_PARTNERS,
  [TRADE_PARTNER_TRADING_SINCE]: COMPANY_TRADE_PARTNERS,
  [TRADE_PARTNER_TRADING_CURRENCY]: COMPANY_TRADE_PARTNERS,
  [TRADE_PARTNER_TOTAL_EXPORT_VOLUME]: COMPANY_TRADE_PARTNERS,
  [TRADE_PARTNER_OUTSTANDING_BALANCE]: COMPANY_TRADE_PARTNERS,
  [TRADE_PARTNER_EXPECTED_EXPORT_VOLUME]: COMPANY_TRADE_PARTNERS,
  [TRADE_PARTNER_AVERAGE_INVOICE_AMOUNT]: COMPANY_TRADE_PARTNERS,
  [TRADE_PARTNER_MAXIMUM_PAYMENT_TERM]: COMPANY_TRADE_PARTNERS,
  [TRADE_PARTNER_PAYMENT_REFERENCE_TYPE]: COMPANY_TRADE_PARTNERS,
  [TRADE_PARTNER_HAS_DELAY_IN_PAYMENTS]: COMPANY_TRADE_PARTNERS,
  [TRADE_PARTNER_MAXIMUM_DELAY_IN_DAYS]: COMPANY_TRADE_PARTNERS,
  [TRADE_PARTNER_DOCUMENTS_ROUTED_THROUGH_BANK]: COMPANY_TRADE_PARTNERS,
  [TRADE_PARTNER_INVOICE_DOCUMENT]: COMPANY_TRADE_PARTNERS,
  [TRADE_PARTNER_PURCHASE_ORDER_DOCUMENT]: COMPANY_TRADE_PARTNERS,
  [TRADE_PARTNER_SAMPLE_DOC_STATEMENT_OF_ACCOUNTS]: COMPANY_TRADE_PARTNERS,
  [TRADE_PARTNER_SAMPLE_DOC_AGING_REPORT]: COMPANY_TRADE_PARTNERS,
  [TRADE_PARTNER_BILL_OF_LADING_DOCUMENT]: COMPANY_TRADE_PARTNERS,
  [TRADE_PARTNER_AIRWAY_BILL_DOCUMENT]: COMPANY_TRADE_PARTNERS,
  [TRADE_PARTNER_CRM_CIM_DOCUMENT]: COMPANY_TRADE_PARTNERS,
  [TRADE_PARTNER_EBRC_DOCUMENT]: COMPANY_TRADE_PARTNERS,
  [TRADE_PARTNER_SUPPORTING_DOCUMENT]: COMPANY_TRADE_PARTNERS,
  [TRADE_PARTNER_AGREEMENT]: COMPANY_TRADE_PARTNERS,
  [TRADE_PARTNER_PROOF_OF_PAYMENT]: COMPANY_TRADE_PARTNERS,

  [SELLER_BANK_ACCOUNT_TRANSFER_TYPE]: COMPANY_SELLER_BANK_ACCOUNT,
  [SELLER_BANK_ACCOUNT_CURRENCIES]: COMPANY_SELLER_BANK_ACCOUNT,
  [SELLER_BANK_ACCOUNT_ACCOUNT_HOLDER]: COMPANY_SELLER_BANK_ACCOUNT,
  [SELLER_BANK_ACCOUNT_ACCOUNT_NUMBER]: COMPANY_SELLER_BANK_ACCOUNT,
  [SELLER_BANK_ACCOUNT_BANK_CODE]: COMPANY_SELLER_BANK_ACCOUNT,

  // DIRECT DEBIT BANK ACCOUNT
  [DIRECT_DEBIT_ACCOUNT_ACCOUNT_HOLDER]: COMPANY_DIRECT_DEBIT_BANK_DETAILS,
  [DIRECT_DEBIT_ACCOUNT_ACCOUNT_NUMBER]: COMPANY_DIRECT_DEBIT_BANK_DETAILS,
  [DIRECT_DEBIT_ACCOUNT_BANK_CODE]: COMPANY_DIRECT_DEBIT_BANK_DETAILS,
  [DIRECT_DEBIT_ACCOUNT_BANK_NAME]: COMPANY_DIRECT_DEBIT_BANK_DETAILS,
  [DIRECT_DEBIT_ACCOUNT_CITY]: COMPANY_DIRECT_DEBIT_BANK_DETAILS,
  [DIRECT_DEBIT_ACCOUNT_COUNTRY_CODE]: COMPANY_DIRECT_DEBIT_BANK_DETAILS,
  [DIRECT_DEBIT_ACCOUNT_STATE]: COMPANY_DIRECT_DEBIT_BANK_DETAILS,
  [DIRECT_DEBIT_ACCOUNT_STREET_NAME]: COMPANY_DIRECT_DEBIT_BANK_DETAILS,
  [DIRECT_DEBIT_ACCOUNT_STREET_NUMBER]: COMPANY_DIRECT_DEBIT_BANK_DETAILS,
  [DIRECT_DEBIT_ACCOUNT_ZIP_CODE]: COMPANY_DIRECT_DEBIT_BANK_DETAILS,
}
